import {
  Container,
  ContainerGutter,
  Text,
  TokenTextAppearance,
  TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React, {ReactElement} from 'react';
import {
  CardImage,
  CardImageContainer,
  CardInfoContainerLayer,
} from '../ui/id-mirror-card-styles';
import {useIdMirrorTheme} from '../../../hooks/use-id-mirror-theme';

interface IdMirrorCardProps {
  titleLight: string;
  descriptionLight: ReactElement;
  imageLight: string;

  titleDark: string;
  descriptionDark: ReactElement;
  imageDark: string;

  cardNumber: string;
  isMobileCard?: boolean;

  cardInfoLightRef?: React.Ref<HTMLDivElement>;
  cardInfoDarkRef?: React.Ref<HTMLDivElement>;
}

export const IdMirrorCard = ({
  titleLight,
  descriptionLight,
  imageLight,
  titleDark,
  descriptionDark,
  imageDark,
  cardNumber,
  isMobileCard = false,
  cardInfoLightRef,
  cardInfoDarkRef,
}: IdMirrorCardProps) => {
  const {theme} = useIdMirrorTheme();

  const gap = isMobileCard
    ? 'var(--size-dynamic0140)'
    : 'var(--size-dynamic0040)';

  const renderContent = (
    title: string,
    description: ReactElement,
    image: string,
  ) => (
    <>
      <Container
        data-testid="card-text-container"
        wrap="always"
        gutter={ContainerGutter.static250}
      >
        <Text
          bold
          appearance={TokenTextAppearance.headline300}
          color={TokenTextColor.inverted}
        >
          {title}
        </Text>
        <Text
          appearance={
            isMobileCard
              ? TokenTextAppearance.copy100
              : TokenTextAppearance.copy200
          }
          color={TokenTextColor.inverted}
        >
          {description}
        </Text>
      </Container>
      <CardImageContainer>
        <CardImage src={image} title={title} alt={`card-image-${cardNumber}`} />
      </CardImageContainer>
    </>
  );

  return (
    <div
      style={{position: 'relative', height: '100%'}}
      className="card-layers-container"
    >
      <CardInfoContainerLayer
        className="card-layer-dark"
        ref={cardInfoDarkRef}
        gap={gap}
        style={{opacity: theme === 'dark' ? 1 : 0}}
      >
        {renderContent(titleDark, descriptionDark, imageDark)}
      </CardInfoContainerLayer>
      <CardInfoContainerLayer
        className="card-layer-light"
        ref={cardInfoLightRef}
        gap={gap}
        absolute
        style={{opacity: theme === 'light' ? 1 : 0}}
      >
        {renderContent(titleLight, descriptionLight, imageLight)}
      </CardInfoContainerLayer>
    </div>
  );
};
